module.exports = __webpack_public_path__ + "img/redeemed.fbb11717.webp";